import { render, staticRenderFns } from "./KeyRow.vue?vue&type=template&id=b4989806&scoped=true&"
import script from "./KeyRow.vue?vue&type=script&lang=ts&"
export * from "./KeyRow.vue?vue&type=script&lang=ts&"
import style0 from "./KeyRow.vue?vue&type=style&index=0&id=b4989806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4989806",
  null
  
)

export default component.exports